import { render, staticRenderFns } from "./EditEPaper2.vue?vue&type=template&id=63422f64&scoped=true"
import script from "./EditEPaper2.vue?vue&type=script&lang=js"
export * from "./EditEPaper2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63422f64",
  null
  
)

export default component.exports